import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <motion.section
      id="about"
      className="section"
      initial={{ opacity: 0, scale: 0.8, filter: "blur(10px)" }}
      whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.5 }}
    >
      <div className="container">
        <h2 className="headline-2">About Me</h2>
        <div className="bg-zinc-800/50 p-7 rounded-2xl mt-3 md:p-12 md:flex md:flex-row-reverse md:justify-between">
          <div className="mb-4 md:mb-0 md:w-1/3">
            <img src="/images/Profile.jpg" alt="Profile" className="rounded-2xl p-2" />
          </div>
          <p className="text-zinc-300 mb-4 md:mb-8 md:text-l md:max-w-[75ch] md:w-2/3">
            Hi, I'm Pearl. I'm someone who enjoys understanding how things work,
            breaking them apart, and building them back better. Whether it's securing
            cloud infrastructure, automating repetitive tasks, or developing full-stack
            applications, I love creating solutions that are practical, reliable, and
            easy to use.
            <br /><br />
            Over the past few years, I've explored everything from backend development
            and cloud technologies to cybersecurity and DevSecOps. During my internship
            at GoDaddy, I worked on enterprise Identity and Access Management (IAM),
            security automation, and production support, which sparked my interest in
            cloud security and infrastructure.
            <br /><br />
            I enjoy building projects that challenge me, from developing
            <strong> Aegis Cloud Sentinel</strong>, an AWS Cloud Security Posture
            Management platform, to creating <strong>Memosac</strong>, a secure digital
            vault, and experimenting with IoT and AI. Every project teaches me something
            new, and that's what keeps me building.
            <br /><br />
            Away from the keyboard, you'll usually find me out in nature, taking
            photographs, exploring new places, or simply enjoying the drive. I believe
            curiosity doesn't stop with technology, and some of the best ideas come when
            you're away from the screen.
          </p>
        </div>
      </div>
    </motion.section>
  );
};

export default About;